import React, { useState, useEffect } from 'react'
import { useParams } from "react-router-dom";
import VisualizacaoPadrao from '../../../../components/VisualizacaoPadrao'
import { get } from '../../../../util/AcessoApi'
import { ordenarArrayObj } from '../../../../util/FuncoesComuns'
import { visualizar } from '../../../../util/AcessoApi'
import { ModalPadraoCadastro } from '../../../../components/Modais'

const VisualizacaoUsuarioApp = (props) => {
    let { id } = useParams();
    const [dados, setDados] = useState({})


    useEffect(() => {
        if (id) {
            visualizar(`/devolucao/lote`, id, obj => {
                setDados(obj)
            })
        }
    }, [id])

    const data = dados.id ? {
        titulo: 'Visualização de Devolução',
        grupos: [
            {
                titulo: 'Dados Gerais',
                colunas: [
                    {
                        titulo: 'Código',
                        descricao: dados.id,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Cooperado',
                        descricao: dados.cooperado.label,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Devolvido?',
                        descricao: dados.devolvido_descricao,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Data Devolução',
                        descricao: dados.data_devolucao,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Status',
                        descricao: dados.status_descricao,
                        tamanho: 'col-lg-6'
                    },
                    {
                        titulo: 'Data Registro',
                        descricao: dados.data_registro,
                        tamanho: 'col-lg-6'
                    }
                ]
            }, {
                tipoGrupo: 'tabela',
                titulo: 'Comprovante(s)',
                thead:
                    <tr>
                        <td className='coluna-1'>#</td>
                        <td className='coluna-1'>Código</td>
                        <td className='coluna-1'>Cód. Barras</td>
                        <td className='coluna-4'>Nome</td>
                        <td className='coluna-1'>Tipo Pessoa</td>
                        <td className='coluna-1'>Convênio</td>
                        <td className='coluna-1'>Hospital</td>
                        <td className='coluna-3'>Status</td>
                    </tr>,
                tbody: dados.comprovantes == undefined || dados.comprovantes.length < 1 ? (<><tr>
                    <td colspan="3">Sem Registro!</td>
                </tr></>) :
                    ordenarArrayObj(dados.comprovantes, 'id').map((comprovante, index) =>
                        <tr>
                            <td>{index + 1}</td>
                            <td>{comprovante.codigo_comprovante}</td>
                            <td>{comprovante.codigo_barras}</td>
                            <td>{comprovante.nome}</td>
                            <td>{comprovante.tipo_pessoa}</td>
                            <td>{comprovante.convenio}</td>
                            <td>{comprovante.hospital}</td>
                            <td>{comprovante.status}</td>
                        </tr>)
            }
        ]
    } : { titulo: 'Visualização de Devolução' }

    return (
        <VisualizacaoPadrao data={data} id={id} {...props} />
    )
}

const DetalhesComprovante = (props) => {
    const [itemDetalhes, setItemDetalhes] = useState({});

    useEffect(() => {
        setItemDetalhes(props.itemDetalhes)
    }, [props.itemDetalhes])

    return <ModalPadraoCadastro titulo={props.titulo || 'Detalhes Comprovante'} showModal={props.showModal} setShowModal={props.setShowModal}>
        <div>
            {itemDetalhes && itemDetalhes.hospital ?
                <div className='detalhes'>
                    <div className='item-detalhes'>
                        <h6><b>Código</b></h6>
                        <h6>{itemDetalhes.codigo_comprovante}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Código de Barras</b></h6>
                        <h6>{itemDetalhes.codigo_barras}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Nome</b></h6>
                        <h6>{itemDetalhes.nome}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Cooperado</b></h6>
                        <h6>{itemDetalhes.cooperado}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>N° Guia</b></h6>
                        <h6>{itemDetalhes.n_guia || '--'}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Convênio</b></h6>
                        <h6>{itemDetalhes.convenio_nome}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Hospital</b></h6>
                        <h6>{itemDetalhes.hospital_nome}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Tipo Pessoa</b></h6>
                        <h6>{itemDetalhes.tipo_pessoa}</h6>
                    </div>
                    <hr />
                    <div className='item-detalhes'>
                        <h6><b>Status</b></h6>
                        <h6>{itemDetalhes.status}</h6>
                    </div>
                    <hr />
                </div> : <></>}
        </div>
    </ModalPadraoCadastro >
}

export default VisualizacaoUsuarioApp

export { DetalhesComprovante }